import React from 'react';
import { useTranslation } from 'react-i18next';
import RegisterForm from '../partials/RegisterForm';
import RegisterImg from '../assets/images/register.webp';
import InstagramIcon from '../assets/images/instagram.svg';
import FacebookIcon from '../assets/images/facebook.svg';

import HomeHeader from '../partials/HomeHeader';
import About from '../partials/About';
import HowItWorks from '../partials/HowItWorks';
import Models from '../partials/Models';
import Diversity from '../partials/Diversity';
import Videos from '../partials/Videos';
import Testimonials from '../partials/Testimonials';

export default function Home () {

	const { t } = useTranslation();
 	
	return (
		<>
			<main id="main">
				<div className="w-full lg:grid lg:grid-cols-2 bg-gray-800">
					<div className="h-full">
						<div className="text-white flex flex-col items-center justify-center p-8 lg:p-16 w-full h-full max-h-screen max-lg:pt-28">
							<p className="font-poppins max-lg:text-center text-lg lg:text-2xl">{ process.env.REACT_APP_DESCRIPTION }</p>
						</div>
					</div>

					<div className="max-lg:py-8 w-full flex flex-col p-4 md:p-8 lg:p-16 gap-2 lg:gap-4 items-center justify-center bg-gray-200 lg:pt-28" id="subscribe">
						<h2 className="mb-4 text-5xl text-center w-full font-poppins font-bold text-black">{ t('subscribe') }</h2>
						<div className="bg-white rounded p-8 w-full md:shadow-lg">
							<RegisterForm />
						</div>
					</div>
				</div>
			</main>
		</>
	);
}
